import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import Product from 'src/app/model/product/product';
import PMSColor from 'src/app/model/company/pmscolor';
import ProductCompanyPMSColor from 'src/app/model/product/product-company-pmscolor';
import {
  RequestService,
  DEBOUNCE_TIME,
} from 'src/app/services/request.service';
import { LoadingService } from 'src/app/services/loading.service';
import { Subject } from 'rxjs';
import Company from 'src/app/model/company/company';

@Component({
  selector: 'customer-project-info-one',
  templateUrl: './customer-project-info-one.component.html',
  styleUrls: ['./customer-project-info-one.component.scss'],
})
export class CustomerProjectInfoOneComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  @Input()
  public inputCompany: Company;
  @Input()
  public inputProduct: Product;
  @Input()
  public pmsColorAdded: Subject<PMSColor>;
  @Output()
  public update = new EventEmitter();

  public pcps: ProductCompanyPMSColor[] = [];
  public selectedColors: PMSColor[] = [];
  public filteredColors: PMSColor[] = [];
  public colorsForm: UntypedFormGroup;
  public newColorName: string = '';
  pmsColorDisplay: string = '';

  private extraInfoChanged: Subject<string> = new Subject();

  constructor(
    private requestService: RequestService,
    private loadingService: LoadingService
  ) {
    super();
  }

  ngOnInit() {
    if (
      this.inputCompany.pmsColors != null &&
      this.inputCompany.pmsColors.length > 0
    ) {
      this.filteredColors = this.inputCompany.pmsColors.filter(
        (c) => !c.archived
      );
    }
    if (this.inputProduct.productCompanyPMSColors != null) {
      this.inputProduct.productCompanyPMSColors.forEach((pcp) => {
        if (pcp.company.id === this.inputCompany.id) {
          this.selectedColors.push(pcp.pmsColor);
          this.pcps.push(pcp);
        }
      });
    }
    this.buildColorsForm();
    this.calculatePmsColorDisplay();
    this.addSubscription(
      this.extraInfoChanged,
      () => {
        this.saveExtraInfoToServer();
      },
      (err) => {},
      DEBOUNCE_TIME
    );
    if (this.pmsColorAdded != null) {
      this.addSubscription(this.pmsColorAdded, (pmsColor) => {
        this.addColorToOptions(pmsColor);
      });
    }
  }

  buildColorsForm() {
    this.colorsForm = new UntypedFormGroup({
      pmsColors: new UntypedFormControl(''),
    });
  }

  selectedColorsChanged(event: PMSColor[]) {
    let newProductCompanyPmsColors: ProductCompanyPMSColor[] = [];
    if (this.pcps != null) {
      this.pcps.forEach((pcp) => {
        if (
          event.some((c) => {
            return c.id === pcp.pmsColor.id;
          })
        ) {
          newProductCompanyPmsColors.push(pcp);
        }
      });
    }
    event.forEach((c) => {
      if (
        !newProductCompanyPmsColors.some((pcp) => {
          return c.id === pcp.pmsColor.id;
        })
      ) {
        let pcp = new ProductCompanyPMSColor();
        pcp.company = this.inputCompany;
        pcp.pmsColor = c;
        newProductCompanyPmsColors.push(pcp);
      }
    });
    this.pcps = newProductCompanyPmsColors;
    this.update.emit();
  }

  addColorToCompany() {
    let toAdd = new PMSColor();
    toAdd.name = this.newColorName;
    toAdd.company = this.inputCompany;

    this.loadingService.isLoading();
    this.addSubscription(
      this.requestService.post(toAdd, '/pmsColors', 'json'),
      (res) => {
        if (this.inputCompany.pmsColors != null) {
          this.inputCompany.pmsColors.push(res);
        } else {
          this.inputCompany.pmsColors = [];
          this.inputCompany.pmsColors.push(res);
        }
        this.pmsColorAdded.next(res);
        this.newColorName = '';
        this.loadingService.isSaved();
      }
    );
  }

  addColorToOptions(pmsColor: PMSColor) {
    if (
      pmsColor != null &&
      pmsColor.company != null &&
      pmsColor.company.id === this.inputCompany.id
    ) {
      this.filteredColors.push(pmsColor);
    }
  }

  colorsExtraInfoChange(event) {
    this.inputCompany.colorsExtraInfo = event;
    this.loadingService.isLoading();
    this.extraInfoChanged.next();
  }

  saveExtraInfoToServer() {
    this.addSubscription(
      this.requestService.putPart(
        this.inputCompany.colorsExtraInfo,
        '/companies/updateColorsExtraInfo',
        this.inputCompany.id
      ),
      (res) => {
        this.loadingService.isSaved();
      }
    );
  }

  compareFn(cat1: any, cat2: any) {
    return cat1 && cat2 ? cat1.id === cat2.id : cat1 === cat2;
  }

  calculatePmsColorDisplay() {
    this.pmsColorDisplay = this.filteredColors
      .map((pms) => pms.name)
      .join(', ');
  }
}
